<template>
  <div class="form-wrapper">
    <div
      v-if="$route.query.step == 1"
      class="dropzone-new layout align-center fill-height justify-center"
      @dragover="onOver"
      @dragleave.prevent="onLeave"
      @drop.prevent.stop.capture="onDrop"
    >
      <div v-show="files.length > 0" class="file-preview">
        <div v-for="(file, index) in files" :key="index" @click="deleteFile(file.name)">
          <v-chip close color="primary" dark label>
            {{ file.name }}
          </v-chip>
        </div>
      </div>
      <div v-show="files.length === 0">
        Drop PDFs
      </div>
    </div>
    <div v-show="$route.query.step == 2" class="task-viewer">
      <div v-if="importedTasks.length === 0" class="empty">
        No Task found in PDF.
      </div>
      <div v-else>
        Found {{ importedTasks.length }} Tasks
        <div class="list">
          <todo-list-item v-for="task in importedTasks" :key="task._id" :task="task" />
        </div>
      </div>
    </div>
    <div class="actions mt-3 layout align-center ">
      <core-button
        v-show="$route.query.step > 1"
        :is-loading="isLoading"
        label="Back"
        secondary
        flat
        not-rounded
        @click.stop="$router.push({ query: { ...$route.query, step: '1' } })"
      />
      <v-spacer />
      <core-button
        v-show="files.length > 0 && $route.query.step == 1"
        :is-loading="isLoading"
        label="Upload"
        flat
        not-rounded
        @click.stop="upload"
      />
      <core-button
        v-show="$route.query.step == 2"
        :disabled="importedTasks.length === 0"
        :is-loading="isLoading"
        label="Import Tasks"
        flat
        not-rounded
        @click.stop="setActive"
      />
    </div>
  </div>
</template>

<script>
import CoreButton from '../../../buttons/CoreButton';
import { IMPORT_TASKS_FROM_PDF, UPDATE_TASK_ACTIVE } from '../../../../../config/constants';
import { mapState } from 'vuex';
import { groupBy } from 'lodash';
import TodoListItem from '../../../../todos/TodoListItem';
export default {
  name: 'ImportTasks',
  components: { TodoListItem, CoreButton },
  data() {
    return {
      files: [],
      isLoading: false
    };
  },
  computed: {
    ...mapState('loop', {
      importedTasks: state => state.tasks.tasksFromPdf.items
    }),
    grouped() {
      return groupBy(this.importedTasks, d => d.slide.name);
    }
  },
  methods: {
    onOver(e) {
      e.preventDefault();
      e.target.style.background = 'var(--lightish-blue)';
    },
    onLeave(e) {
      e.preventDefault();
      e.target.style.background = '';
    },
    onDrop(e) {
      e.preventDefault();
      for (let i = 0; i < e.dataTransfer.files.length; i++) {
        if (e.dataTransfer.files[i].type === 'application/pdf') {
          this.files.push(e.dataTransfer.files[i]);
        }
      }
    },
    async setActive() {
      if (this.importedTasks.length > 0) {
        this.isLoading = true;
        await this.$store.dispatch(UPDATE_TASK_ACTIVE);
        this.isLoading = false;
        this.$store.dispatch('getAllForDashboard');
        this.$router.push({ query: { dialog: null } });
      }
    },
    upload: function() {
      this.isLoading = true;
      const upload = this.files.map(file => {
        return this.$store.dispatch(IMPORT_TASKS_FROM_PDF, file);
      });

      Promise.all(upload)
        .then(s => {
          if (this.importedTasks.length > 0) {
            this.canSubmit = true;
          }
          this.isLoading = false;
          this.$router.push({ query: { ...this.$route.query, step: '2' } });
        })
        .catch(e => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.list {
  min-height: 200px;
  max-height: 400px;
  overflow-y: scroll;
}
.dropzone-new {
  background-color: rgba(0, 0, 0, 0.12);
  height: 200px;
}
</style>
